import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  summaryItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  successIcon: {
    color: theme.palette.success.main,
  },
  skippedIcon: {
    color: theme.palette.text.secondary,
  },
  failedIcon: {
    color: theme.palette.error.main,
  },
  dialogActions: {
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
  },
}))

export default useStyles
